<div
	[ngClass]="{
		'dialog-state-default': state === 'default',
		'dialog-state-success': state === 'success',
		'dialog-state-warning': state === 'warning',
		'dialog-state-error': state === 'error'
	}"
>
	<div class="opague-bg"></div>
	<mat-icon>{{
		state === 'success'
			? 'check_circle'
			: state === 'warning'
			? 'warning'
			: state === 'error'
			? 'dangerous'
			: 'info'
	}}</mat-icon>
	<h4 class="dialog-title">
		{{
			title
				? title
				: state === 'success'
				? ('ROOT.STRINGS.SUCCESS' | translate)
				: state === 'warning'
				? ('ROOT.STRINGS.WARNING' | translate)
				: state === 'error'
				? ('ROOT.STRINGS.ERROR' | translate)
				: ('ROOT.STRINGS.INFO' | translate)
		}}
	</h4>
</div>
